import { Form, Formik } from "formik";
import * as Yup from "yup";
import TextInput from "../inputs/TextInput";
import {
    Flex,
    Text,
    Button,
    Img,
    Box,
    Checkbox,
    Spinner
} from "@chakra-ui/react";
import { useSelector } from "react-redux";

const validationSchema = Yup.object().shape({
    name: Yup.string()
        .required("Por favor, ingrese su nombre")
        .min(3, "El nombre debe tener al menos 3 caracteres"),
    email: Yup.string()
        .email("Por favor, ingrese un correo válido")
        .required("Por favor, ingrese su correo"),
    phone: Yup.string()
        .matches(/[0-9]{0,14}$/, "Por favor, ingrese ún número de teléfono válido")
        .required("Por favor, ingrese su número de teléfono")
        .min(10, "Por favor, ingrese un número de teléfono válido"),
    acceptTerms: Yup.bool()
        .oneOf([true], "Debe aceptar los términos y condiciones"),
});

const PlaceOrderForm = ({ closeModal, handleCreateOrder, loading }) => {
    const order = useSelector((state) => state.orderCreate.order);
    const { items } = order;

    const getAmountOfItemsString = () => {
        if(!items) return "0 artículos";
        if (items.length === 1) {
            return "1 artículo";
        } else {
            return `${items.length} artículos`;
        }
    }

    return (
        <Formik
            initialValues={{
                name: "",
                email: "",
                phone: "",
                acceptTerms: true,
            }}
            validationSchema={validationSchema}
            onSubmit={(values) => {
                const order = {
                    ...values,
                    items: items?.map((item) => ({
                        product: item.product,
                        qty: item.qty,
                    })),
                };
                handleCreateOrder(order);
            }}
        >
            {({ 
                isSubmitting,
                handleBlur,
                handleChange,
                handleSubmit,
                setFieldValue,
                values,
                errors,
                touched
            }) => (
            <Flex flexDir="column">
                <Text fontSize="md" fontWeight="400">Información de Contacto</Text>
                <Text fontSize="sm" color="gray.500">El vendedor lo contactará por los siguientes medios</Text>
                <Flex 
                    w="100%"
                    flexDir="column"
                    justifyContent="center"
                    alignItems="center"
                    py="10px"
                >
                    <Form
                        onSubmit={handleSubmit}
                        initialValues={values}
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                        }}
                    >
                        <TextInput
                            name="name"
                            label="Nombre"
                            placeholder="Ingrese su nombre"
                            type="text"
                            errors={errors.name}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.name}
                            touched={touched.name}
                            disabled={loading}
                        />
                        <TextInput
                            name="email"
                            label="Correo"
                            placeholder="Ingrese su correo"
                            type="email"
                            errors={errors.email}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.email}
                            touched={touched.email}
                            disabled={loading}
                        />
                        <TextInput
                            name="phone"
                            label="Teléfono"
                            placeholder="Ingrese su teléfono"
                            type="tel"
                            errors={errors.phone}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.phone}
                            touched={touched.phone}
                            disabled={loading}
                        />
                    </Form>
                </Flex>
                <Text fontSize="md" fontWeight="400">Resumen de la Orden</Text>
                <Text fontSize="sm" color="gray.500">{getAmountOfItemsString()}</Text>
                <Flex 
                    p={2} 
                    flexDir={"column"} 
                    maxH="250px"
                    overflowY="auto"   
                >
                {items && items?.map((item) => (
                    <Flex key={item.product} p={2} borderBottom="1px solid #ccc">
                        <Box w="70px" h="70px">
                            <Img src={item.images[0]} w="100%" h="100%" objectFit="cover" />
                        </Box>
                        <Box flex="1" p={2}>
                            <Text>{item.name}</Text>
                            <Text fontSize="sm" color="gray.500">{item.qty} x ${item.price} = ${item.qty * item.price}</Text>
                        </Box>
                    </Flex>
                ))}
                </Flex>

                <Checkbox 
                    name="acceptTerms" mt="10px"
                    colorScheme="blue"
                    defaultChecked={false}
                    onChange={(e) => setFieldValue("acceptTerms", e.target.checked)}
                    onBlur={handleBlur}
                    isChecked={values.acceptTerms}
                    isInvalid={errors.acceptTerms && touched.acceptTerms}
                    ml="auto"
                    disabled={loading}
                >
                        <small>Acepto los términos y condiciones</small>
                </Checkbox>
                <Flex minH="20px" color="red.500" ml="auto">
                    <small>
                        {errors.acceptTerms && touched.acceptTerms && errors.acceptTerms}
                    </small>
                </Flex>
                <Flex w="100%" justifyContent="flex-end" my="10px">
                {
                    items?.length > 0 && (
                        <Button 
                            colorScheme="blue" 
                            mr=".3rem"
                            onClick={handleSubmit}
                            isLoading={isSubmitting}
                            disabled={isSubmitting ||
                                !values.acceptTerms ||
                                Object.keys(errors).length > 0 || 
                                Object.keys(touched).length === 0 || 
                                loading
                            }
                            minW="100px"
                        >
                            {
                                loading ? 
                                <Spinner variant="light" size="sm" /> :
                                <Text>Continuar</Text>   
                            }
                        </Button>
                    )
                }
                    <Button 
                        disabled={isSubmitting || loading}
                        onClick={closeModal} variant="ghost">
                        <Text color="gray.600">Cerrar</Text>
                    </Button>
                </Flex>                            
            </Flex>
            )}
        </Formik>
    );

};

export default PlaceOrderForm;

